<ng-container
  *ngIf="articles && articles.length > 0;else noData">
  <div class="card-header">
    <div class="grid-x">
      <div class="cell auto">
        <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">{{"widget.name.".concat(widget.widgetName) | translate}}</h4>
      </div>
      <div class="cell shrink">
      </div>
    </div>
  </div>
  <div class="card-body vertical-center">

    <div style="height: inherit; padding: 0 1rem">
      <ng-container *ngFor="let article of articles">
        <app-widget-publication-article-item [article]="article"
                                             [publicationUrl]="publicationUrl"
                                             [accountId]="accountId"
                                             [widgetName]="widget.widgetName"
                                             [trackAction]="TRACK_ACTION_CLICK_LAST_ARTICLE_ITEM">
        </app-widget-publication-article-item>
      </ng-container>
    </div>

  </div>
  <div class="card-footer">
    <a [href]="this.publicationUrl.concat('?accountId=',this.accountId)"
       target="_blank"
       class="button insito"
       (click)="onClickTrackAction()"
       optim-actions="onClickPublication">
      <span
        [title]="'widget.last-articles.consult-all-articles' | translate">{{'widget.last-articles.consult-all-articles' | translate}}</span>
    </a>
  </div>
</ng-container>
<ng-template #noData>
  <app-widget-message [message]="'widget.last-articles.no-data'| translate"
                      [widgetLabel]="'widget.name.'.concat(widget.widgetName) | translate"
                      [widgetSize]="widget.size"
                      icone="opt-stat"></app-widget-message>
</ng-template>

